export const placeHolders = (limit) => {
  let items = []
  for (var i = 0; i < limit; i++) {
    // must have the same structure as the real data
    items.push({id: i.toString(), images: { header: {url: ''} }, videos: { header: {url: ''} }, author: {id: 0, displayName: ''}, date: 0, title: {text: ''}, content: { bodyHTML: '', previewTextHTML: '' }, reactions: [{type: 'heart', count: 0, viewerHasReacted: false}], url: {web: ''}})
  }
  return items
}



// WEBPACK FOOTER //
// ./assets/js/helpers/PlaceHolders.js